import './Fpv.css';
import React, { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { VfrHudMessage } from '../../../utils/MavMessageTypes';

type TelemetryStatProps = {
    receiveTelemetry: boolean;
    voltage: number;
    vfrHud: VfrHudMessage | undefined;
};

const TelemetryStat: React.FC<TelemetryStatProps> = ({ receiveTelemetry, voltage, vfrHud }) => {
    const [fresh, setFresh] = useState(false);
    const [lastUpdate, setLastUpdate] = useState<number>(Date.now());
    const [age, setAge] = useState(0);

    const [openOnMobile, setOpenOnMobile] = useState(false);

    // Когда приходят новые данные — обновляем время последнего обновления
    useEffect(() => {
        if (vfrHud) {
            setLastUpdate(Date.now());
            setFresh(true);
        }
    }, [vfrHud, voltage]);

    // Таймер, который проверяет устарели ли данные
    useEffect(() => {
        const interval = setInterval(() => {
            const currentAge = Date.now() - lastUpdate;
            setAge(currentAge);
            setFresh(currentAge < 1000);
        }, 300);

        return () => clearInterval(interval);
    }, [lastUpdate]);

    return (
        <>
            {receiveTelemetry && (
                <div className={"telemetry-stat floating-window" + (openOnMobile ? " open" : "")}>
                    <div className="floating-window-header" onClick={() => setOpenOnMobile(!openOnMobile)}>
                        {/* Индикатор статуса с tooltip */}
                        <OverlayTrigger
                            key={String(openOnMobile)}
                            placement="auto"
                            overlay={
                                <Tooltip id="tooltip-status">
                                    {fresh
                                    ? `Данные обновлены ${age} мс назад`
                                    : `Нет обновлений уже ${age} мс`
                                }
                                </Tooltip>
                            }
                        >
                            <div className='telemetry-stat-indicator-row'>
                                <span className={"telemetry-stat-indicator" + (fresh ? " fresh" : "")}></span>
                                <span className="telemetry-stat-text">{fresh ? "Данные актуальны" : "Нет обновлений"}</span>
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="floating-window-content">
                        <div className="telemetry-stat-row">Напряжение: {voltage.toFixed(2)} V</div>
                        <div className="telemetry-stat-row">Высота: {vfrHud?.alt.toFixed(1)} м</div>
                        <div className="telemetry-stat-row">Курс: {vfrHud?.heading}°</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TelemetryStat;